const THEMES = new Map();
const PROMISE_RESOLVER = new Map();
const BASEURL_REGEX = /(url\((?!\s*["']?(?:\/|https?:|data:))\s*["']?)([^'")]+)/g;
const createStyleSheetFromString = (baseUrl, cssText) => new CSSStyleSheet().replace(applyBaseUrl(baseUrl, cssText));
export async function getTheme(themeModel, timeout) {
    const promise = THEMES.get(themeModel.name) ??
        THEMES.set(themeModel.name, createThemePromise(themeModel, timeout)).get(themeModel.name);
    if (themeModel.url) {
        instanceTheme(themeModel);
    }
    return promise;
}
async function createThemePromise(themeModel, timeout) {
    // If it has an inlined styleSheet, directly resolve the promise
    if (themeModel.styleSheet) {
        return Promise.resolve({
            name: themeModel.name,
            styleSheet: await createStyleSheetFromString(themeModel.themeBaseUrl, themeModel.styleSheet)
        });
    }
    return createThemePromiseUrl(themeModel.name, timeout);
}
function createThemePromiseUrl(name, timeout) {
    return new Promise((resolve, reject) => {
        PROMISE_RESOLVER.set(name, {
            name,
            resolve,
            reject,
            timeout: setTimeout(() => promiseTimeout(name), timeout),
            isLoading: false
        });
    });
}
function resolvePromise(resolver, value) {
    disposeResolver(resolver);
    resolver.resolve(value);
}
function rejectPromise(resolver, error) {
    disposeResolver(resolver);
    resolver.reject(error);
}
function promiseTimeout(name) {
    const resolver = PROMISE_RESOLVER.get(name);
    if (resolver) {
        rejectPromise(resolver, new Error(`Theme load timeout: ${name}`));
    }
}
function disposeResolver(resolver) {
    clearTimeout(resolver.timeout);
    PROMISE_RESOLVER.delete(resolver.name);
}
async function instanceTheme(themeModel) {
    const resolver = PROMISE_RESOLVER.get(themeModel.name);
    if (resolver && !resolver.isLoading) {
        resolver.isLoading = true;
        try {
            const styleSheet = await loadThemeStyleSheet(themeModel.url, themeModel.themeBaseUrl);
            resolvePromise(resolver, { name: themeModel.name, styleSheet });
        }
        catch (error) {
            rejectPromise(resolver, error);
        }
    }
}
async function loadThemeStyleSheet(url, baseUrl) {
    try {
        return createStyleSheetFromString(baseUrl, await requestStyleSheet(url));
    }
    catch (error) {
        throw new Error(`Failed to load theme stylesheet: ${error}`);
    }
}
async function requestStyleSheet(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.text();
    }
    catch (error) {
        throw new Error(`Failed to fetch stylesheet: ${error.message}`);
    }
}
/**
 * @example
 * const baseUrl = "https://example.com/"
 * const cssText = "background-image: url(images/background.png);"
 *
 * result: "background-image: url(https://example.com/images/background.png);"
 */
function applyBaseUrl(baseUrl, cssText) {
    if (baseUrl) {
        return cssText.replace(BASEURL_REGEX, `$1${baseUrl}$2`);
    }
    return cssText;
}
